import type { Token } from "./auth";

const key = "v_impersonation_v1";

// sessionStorage isolates account selection between tabs. Bind it to the login
// session so signing in as another user cannot restore an old selection.
export const impersonationSession = {
  get(token: Token): string | null {
    if (!token.adminId || token.merchantId) return null;
    try {
      const stored = sessionStorage.getItem(key);
      if (!stored) return null;
      const value: unknown = JSON.parse(stored);
      if (
        typeof value === "object" &&
        value !== null &&
        "adminId" in value &&
        value.adminId === token.adminId &&
        "sessionId" in value &&
        value.sessionId === token.jti &&
        "merchantId" in value &&
        typeof value.merchantId === "string"
      ) {
        return value.merchantId;
      }
    } catch {
      // Invalid or old tab state should send the admin back to the account list.
    }
    return null;
  },
  set(token: Token, merchantId: string) {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        adminId: token.adminId,
        sessionId: token.jti,
        merchantId,
      }),
    );
  },
  clear() {
    sessionStorage.removeItem(key);
  },
};
